<template>
  <div
    class="section"
    title="Click to edit..."
    @click="onSectionClick"
  >
    <p class="m-0 text-support text-sm font-bold">
      {{ name }}
    </p>

    <v-icon
      name="pencil-alt"
      class="header-icon ml-auto self-center"
      scale="0.7"
    />

    <v-icon
      name="bars"
      class="header-icon header-icon-grab ml-2 self-center"
      scale="0.8"
    />
  </div>
</template>

<script>
export default {
  name: "Section",
  props: {
    name: {
      required: true,
      type: String
    },
    sectionId: {
      required: true,
      type: String
    }
  },
  methods: {
    onSectionClick() {
      this.$gtm.trackEvent({
        event: "promo-section-edit",
        sectionName: this.name,
        sectionId: this.sectionId,
        campaignId: this.$route.params.id
      });

      this.$emit("section-click", this.sectionId, this.name);
    }
  }
};
</script>

<style scoped>
.section {
  @apply flex p-4 cursor-pointer select-none border-grey-light bg-brand-light border mb-5 rounded-lg shadow text-sm;

  &:hover {
    background-color: #f3f9f4;
  }

  @screen lg {
    @apply text-base;
  }
}

.header-icon {
  @apply text-grey-light;
  cursor: pointer;
}

.header-icon-grab {
  cursor: grab;
}

.section-settings {
  @apply p-4;
}
</style>
